<template>
  <div class="model-choice">
    <div class="choice-item">
      <img :src="Scane" class="icon" />
      <div class="title">扫一扫</div>
    </div>
    <div class="choice-item" @click="GoNav">
      <img :src="Input" class="icon" />
      <div class="title">输入水杯编号</div>
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    computed: {
      ...SetImage(['Scane', 'Input'])
    },
    methods: {
      GoNav () {
        console.log(this.edit)
        this.$nav('Common.InputNumber', { 'id': this.edit })
      }
    },
    props: {
      edit: null
    }
  }
</script>

<style lang="less" scoped>
  .model-choice {
    .h(3.3rem);
    display: flex;
    .choice-item {
      flex: 1;
      .flex-ccc();
      .icon {
        .w(1.1rem);
        .h(1.1rem);
        .mb(.27rem);
      }
      .title {
        .fz(.26rem);
        .c(#999);
      }
    }
  }
</style>
